<template>
  <div>
    <div class="pop_ul scrollBar">
      <div class="tabs">
        <div
          :class="
            (isshow == 0 ? 'tab_li mr' : 'tab_li') +
            ($route.params.is3 == 1 ? '' : ' tab_li2')
          "
          @click="isshow = 0"
        >
          <img v-if="isshow != 0" src="@/assets/img/isshow0.png" />
          <img v-if="isshow == 0" src="@/assets/img/isshow01.png" />
          <div></div>
        </div>
        <div
          :class="
            (isshow == 1 ? 'tab_li mr' : 'tab_li') +
            ($route.params.is3 == 1 ? '' : ' tab_li2')
          "
          @click="isshow = 1"
        >
          <img v-if="isshow != 1" src="@/assets/img/isshow1.png" />
          <img v-if="isshow == 1" src="@/assets/img/isshow11.png" />
          <div></div>
        </div>
        <div
          :class="isshow == 2 ? 'tab_li mr' : 'tab_li'"
          @click="isshow = 2"
          v-if="$route.params.is3 == 1"
        >
          <img v-if="isshow != 2" src="@/assets/img/isshow2.png" />
          <img v-if="isshow == 2" src="@/assets/img/isshow21.png" />
          <div></div>
        </div>
      </div>
      <div
        class="scrollBar"
        :style="{ height: bodyHeight - 140 + 'px', position: 'relative'}"
        v-if="isshow == 0"
      >
        <div
          :class="pop.id === val.id ? 'pop_li mr' : 'pop_li'"
          v-for="(val, key) in list"
          :key="key"
          @click="getpopli(val)"
        >
          <div class="pop_li_t">
            {{ val.title }}
            <span>{{ val.createtime }}</span>
          </div>
          <div class="pop_li_c">{{ val.content }}</div>
        </div>
        <div class="noData" v-if="list.length <= 0 && status">
          {{ $t("whatsApp.txt1") }}
        </div>
        <div class="pagination" v-if="code > 0">
          <el-pagination
            @current-change="setPage"
            background
            layout="prev, pager, next"
            :total="code"
          >
          </el-pagination>
        </div>
        <!-- <div class="mes_a">
          <a @click="getlists(1)" v-if="key.page > 3" class=""
            ><img src="@/assets/img/go_l.png"
          /></a>
          <a
            v-if="
              (keys < key.page + 3 || keys < 6) &&
              (keys > key.page - 3 || keys > parseInt(code / 10) - 4)
            "
            @click="getlists(keys)"
            :class="key.page == keys ? 'mr' : ''"
            v-for="keys in parseInt(code / 10) + 1"
            :key="keys"
            >{{ keys }}</a
          >
          <a
            @click="getlists(parseInt(code / 10) + 1)"
            v-if="key.page < parseInt(code / 10) - 1"
            class=""
            ><img src="@/assets/img/go_r.png"
          /></a>
        </div> -->
      </div>
      <div
        class="scrollBar"
        :style="{ height: bodyHeight - 125 + 'px' }"
        v-if="isshow == 1"
      >
        <div v-for="(val, key) in list2" :key="key">
          <div class="Contacts_tit">{{ val.first_char }}</div>
          <div
            @click="dd(valq)"
            :class="pops.id == valq.id ? 'Contacts_li mr' : 'Contacts_li'"
            v-for="(valq, keyq) in val.list"
            :key="keyq"
          >
            <div>
              <img src="@/assets/img/my_avatar.png" alt="" />
            </div>
            {{ valq.name }}
          </div>
        </div>
      </div>
      <div
        class="scrollBar"
        :style="{ height: bodyHeight - 125 + 'px' }"
        v-if="isshow == 2"
      >
        <div
          @click="getpopli2(val)"
          :class="'tel_li ' + (val.id == popss.id ? 'mr' : '')"
          v-for="(val, key) in list1"
          :key="key"
        >
          <img
            v-if="val.is_out == 1 && val.is_on == 1"
            src="@/assets/img/c_go.png"
          />
          <img
            v-if="val.is_out == 1 && val.is_on == 2"
            src="@/assets/img/c_j.png"
          />
          <img
            v-if="val.is_out == 2 && val.is_on == 1"
            src="@/assets/img/c_l.png"
          />
          <img
            v-if="val.is_out == 2 && val.is_on == 2"
            src="@/assets/img/c_w.png"
          />
          <div class="tel_name">
            <div>{{ val.name }}</div>
            {{ val.is_out == 1 ? $t("whatsApp.txt2") : $t("whatsApp.txt3") }}
          </div>
          <div class="tel_time">
            {{ val.createtime }}
          </div>
        </div>
        <div class="noData" v-if="list1.length <= 0 && status1">
          {{ $t("whatsApp.txt1") }}
        </div>
        <div class="pagination" v-if="code1 > 0">
          <el-pagination
            @current-change="setPage1"
            background
            layout="prev, pager, next"
            :total="code1"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div
      id="dialog"
      :style="{ width: bodyWidth - 681 + 'px', height: bodyHeight - 60 + 'px' }"
      v-if="isshow == 0"
    >
      <div class="name">{{ pop.title ? pop.title : "" }}</div>
      <div>
        <div
          class="dialog scrollBar"
          ref="scrollBar"
          :style="{ height: bodyHeight - 139 + 'px' }"
        >
          <div v-for="(val, key) in chat" :key="key">
            <!--  -->
            <!--  -->
            <!-- user_img -->
            <!--  -->
            <div :class="val.is_self != 1 ? 'user' : 'my'">
              <div :class="val.is_self != 1 ? ' user_img' : 'my_img'">
                <img :src="val.avatar" v-if="val.avatar" />
                <img
                  v-else-if="val.is_self != 1"
                  src="@/assets/img/my_avatar.png"
                />
                <img v-else src="@/assets/img/my_avatar.png" />
              </div>
              <div :class="val.is_self != 1 ? 'user_dialog' : 'my_dialog'">
                <div class="time">{{ val.createtime }}</div>
                <div class="content">
                  {{ val.type == 0 ? val.content : val.content }}
                  <img v-if="val.type == 1" :src="val.content" />
                </div>
              </div>
              <!-- <div :class="val.is_self != 1 ? 'user_name' : 'my_name'">
                <div :class="val.is_self != 1 ? 'user_tit' : 'my_tit'">
                  {{ val.title }}
                </div>
                <div :class="val.is_self != 1 ? 'user_time' : 'my_time'">
                  {{ val.createtime }}
                </div>
              </div> -->
            </div>
          </div>
          <!-- <div>
        <img src="http://5b0988e595225.cdn.sohucs.com/images/20180526/3f06e97c457b4a1690fdfa102df44297.jpeg">
        <img src="@/assets/img/download1.png" class="dow">
      </div> -->
        </div>
      </div>
    </div>
    <div
      id="dialog"
      :style="{ width: bodyWidth - 681 + 'px', height: bodyHeight - 60 + 'px' }"
      v-if="isshow == 1"
    >
      <div class="name">{{ pops.name ? pops.name : "" }}</div>
      <div>
        <div class="dialog_img">
          <img src="@/assets/img/my_avatar.png" />
        </div>
        <div class="dialog_name" style="">{{ pops.name ? pops.name : "" }}</div>
        <div class="dialog_num">
          <img src="@/assets/img/c.png" />
          <div class="dialog_num_t">{{ $t("whatsApp.txt4") }}</div>
          <div class="dialog_num_c">{{ pops.Numbers }}</div>
        </div>
        <div class="dialog_num">
          <img src="@/assets/img/e.png" />
          <div class="dialog_num_t">{{ $t("whatsApp.txt5") }}</div>
          <div class="dialog_num_c">{{ pops.Emails }}</div>
        </div>
      </div>
    </div>
    <div
      id="dialog"
      :style="{ width: bodyWidth - 681 + 'px', height: bodyHeight - 60 + 'px' }"
      v-if="isshow == 2 && popss.createtime"
    >
      <div class="name">{{ popss.name }}</div>
      <div>
        <div class="dialog_img">
          <img src="@/assets/img/my_avatar.png" />
        </div>
        <div class="dialog_name" style="">{{ popss.name }}</div>
        <div class="dialog_num msg3">
          <div class="dialog_num_t">{{ popss.date }}</div>
          <div class="dialog_num_c">
            {{ popss.time }}
            <span style="margin: 0 20px">
              {{ popss.is_on == 2 ? $t("whatsApp.txt6") : $t("whatsApp.txt7") }}
              {{ $t("whatsApp.txt8") }}</span
            >
            <!-- ({{ popss.length || 0 }} min) -->
          </div>
        </div>
        <!-- <div class="dialog_num msg3">
          <div class="dialog_num_t">Numbers</div>
          <div class="dialog_num_c">{{ popss.pkg }}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  SocailMsg,
  Socailmsg,
  SocailMsgGetChatDetail,
  SocailmsgGetCallLog
} from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      key: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 10,
        popli: {},
        pkg: this.$route.params.pkg
      },
      key1: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 10,
        pkgId: this.$route.params.pkg
      },
      key2: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 20,
        pkg: this.$route.params.pkg
      },
      bodyHeight: document.body.clientHeight || window.innerHeight,
      bodyWidth: document.body.clientWidth || window.innerWidth,
      isshow: 0,
      list: [],
      list1: [],
      list2: [],
      code: 0,
      code1: 0,
      pop: {
        id: '',
        title: '',
        content: '',
        createtime: '',
        pkg: ''
      },
      pops: {
        name: '',
        Numbers: '',
        Emails: ''
      },
      popss: {
        createtime: 0,
        id: 1,
        isout: 0,
        length: 0,
        name: '',
        pkg: '',
        state: 1
      },
      chat: [],
      msg: '',
      status: false,
      status1: false
    }
  },
  mounted () {
    this.getlist()
    console.log('new page', this.$route.params)
  },
  methods: {
    setPage (e) {
      this.key.page = e
      this.getlists()
    },
    setPage1 (e) {
      this.key1.page = e
      this.getlists1()
    },
    getlist () {
      this.status = false
      this.status1 = false
      SocailMsg(this.key).then((adj) => {
        this.status = true
        if (adj.data.list.length > 0) {
          this.list = adj.data.list
          console.log(this.list,'list');
          this.code = adj.data.count
          console.log(adj.data.count,'adj.data.count');
          if (this.list.length > 0) {
            this.getpopli(this.list[0])
          }
        }
      })
      Socailmsg(this.key2).then((adj) => {
        this.list2 = adj.data
        if (this.list2.length > 0) {
          this.dd(adj.data[0].list[0])
        }
      })
      if (Number(this.$route.params.is3) === 1) {
        SocailmsgGetCallLog({
          ...this.key1,
          pkg: this.key1.pkgId
        }).then((adj) => {
          this.status1 = true
          // console.log(adj)
          this.list1 = adj.data
          this.code1 = this.list1.length
          if (this.list1.length > 0) {
            this.getpopli2(this.list1[0])
          }
        })
      }
    },
    getlists (a) {
      if (a) {
        this.key.page = a
      }
      this.list = []
      this.status = false
      SocailMsg(this.key).then((adj) => {
        this.list = adj.data.list
        this.code = adj.data.count
        this.status = true
      })
    },
    getlists1 (a) {
      if (a) {
        this.key2.page = a
      }
      this.list1 = []
      this.status1 = false
      SocailmsgGetCallLog({
        ...this.key1,
        pkg: this.key1.pkgId
      }).then((adj) => {
        console.log(adj)
        this.list1 = adj.data.list
        this.code1 = adj.data.count
        // + 20
        this.status1 = true
      })
    },
    dd (a) {
      console.log(a)
      this.pops = a
    },
    getpopli (val) {
      this.pop = val
      this.chat = []
      var key = {
        targetuser: val.title,
        equipment_id: localStorage.getItem('systemId'),
        pkg: this.$route.params.pkg,
        page: 1,
        limit: 9999
      }
      SocailMsgGetChatDetail(key).then((adj) => {
        this.chat = adj.data.list
        this.$nextTick(() => {
          let scrollDom = this.$refs.scrollBar
          scrollDom.scrollTop = scrollDom.scrollHeight
        })
      })
    },
    getpopli2 (val) {
      this.popss = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs {
  width: 100%;
  border-bottom: 1px solid #e1e3e6;
  position: absolute;
  top: 0;
  z-index: 1;
  background: #fff;

  height: 77px;
}
.tabs .tab_li {
  float: left;
  width: 110px;
  height: 44px;
  line-height: 40px;
  font-size: 14px;
  color: #000927;
  text-align: center;
  margin-top: 34px;
  position: relative;
  cursor: pointer;
}
.pagination{
  position: static !important;
}
.tabs .tab_li:first-child {
  margin-left: 27px;
}
.tabs .tab_li.tab_li2 {
  width: 170px;
}
.tabs .tab_li img {
  display: block;
  width: 20px;
  height: 20px;
  margin: 7px auto 0;
}
.tabs .tab_li div {
  display: none;
  position: absolute;
  bottom: 0;
  width: 80px;
  height: 4px;
  border-radius: 4px 4px 0 0;
  background: #00eec3;
  left: 15px;
}
.tabs .tab_li.tab_li2 div {
  width: 140px;
}
.tabs .tab_li.mr {
  font-weight: 700;
}
.tabs .tab_li.mr div {
  display: block;
}
.tel_li {
  width: 100%;
  overflow: hidden;
  height: 80px;
  border-bottom: 1px solid #e1e3e6;
}
.tel_li.mr {
  background: rgba(0, 238, 195, 0.1);
}
.tel_li img {
  float: left;
  width: 24px;
  display: block;
  height: 24px;
  margin: 28px 0 0 30px;
}
.tel_name {
  float: left;
  line-height: 20px;
  margin: 20px 0 0 15px;
  font-size: 13px;
  color: #45484d;
}
.tel_name div {
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
.tel_time {
  float: right;
  line-height: 20px;
  font-size: 12px;
  color: #9f9f9f;
  height: 20px;
  margin: 30px 20px 0 0;
}
.pop_ul {
  float: left;
  width: 419px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  height: 100%;
  position: absolute;
  left: 0;
  overflow: auto;
}
.pop_ul .scrollBar {
  margin-top: 79px;
}
.pop_li {
  width: 85%;
  padding: 20px 30px;
  margin: 0;
  border-bottom: 1px solid #e1e3e6;
}
.pop_li.mr {
  background: rgba(0, 238, 195, 0.1);
}
.pop_li_t {
  font-size: 14px;
  line-height: 20px;
  color: #000927;
  font-weight: 700;
  overflow: hidden;
}
.pop_li_t span {
  font-size: 12px;
  line-height: 20px;
  color: #9f9f9f;
  font-weight: 400;
  float: right;
}
.pop_li_c {
  font-size: 13px;
  line-height: 20px;
  color: #45484d;
}
.mes_a {
  margin: 20px auto;
  overflow: hidden;
}
.mes_a a {
  float: left;
  display: block;
  width: 32px;
  height: 32px;
  border: 1px solid #9f9f9f;
  border-radius: 6px;
  margin-left: 8px;
  color: #9f9f9f;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
}
.mes_a a:first-child {
  margin-left: 0;
}
.mes_a a.mr {
  background: #00eec3;
  color: #000927;
  border-color: #00eec3;
}
.mes_a a img {
  display: block;
  width: 16px;
  height: 16px;
  margin: 8px;
}
#dialog {
  position: fixed;
  top: 60px;
  right: 0;
  background: #fff;
  border-left: 1px solid #e1e3e6;
}
#dialog .name {
  width: 100%;
  height: 77px;
  line-height: 77px;
  border-bottom: 1px solid #e1e3e6;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  text-indent: 40px;
}
#dialog .dialog {
  width: 100%;
  overflow: auto;
}
#dialog .user {
  overflow: hidden;
  margin-top: 20px;
}
#dialog .user_img {
  float: left;
  /* width: 40px;
  height: 40px; */
  border-radius: 20px;
  overflow: hidden;
  margin-left: 20px;
  margin-top: 20px;
}
#dialog .user_img img {
  float: left;
  width: 40px;
  height: 40px;
  display: block;
}
#dialog .user_name {
  float: left;
  overflow: hidden;
  margin-left: 10px;
}
#dialog .user_tit {
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
#dialog .user_time {
  font-size: 11px;
  color: #9f9f9f;
}
.user_dialog {
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}
.time {
  font-family: Noto Sans;
  font-size: 11px;
  color: #9f9f9f;
  margin: 4px auto 4px 10px;
}
.user_dialog .content {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 0 12px 12px 12px;
  background: #e7e9eb;
  max-width: 600px;
  margin: 4px auto 4px 10px;
  width: auto;
  float: left;
  max-width: 380px;
  word-break: break-all;
}
/* .user_dialog div {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 0 12px 12px 12px;
  background: #e7e9eb;
  max-width: 360px;
  margin: 4px auto 4px 20px;
  width: auto;
  float: left;
  position: relative;
} */
.user_dialog div img {
  display: block;
  width: 100%;
}
.user_dialog .dow {
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  left: 18px;
  bottom: 18px;
  cursor: pointer;
}
#dialog .my {
  overflow: hidden;
  margin-top: 20px;
}
#dialog .my_img {
  float: right;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  /* overflow: hidden; */
  margin-right: 40px;
  margin-top: 20px;
}
#dialog .my_img img {
  float: right;
  width: 40px;
  height: 40px;
  display: block;
}
#dialog .my_name {
  float: right;
  overflow: hidden;
  margin-right: 10px;
}
#dialog .my_tit {
  font-size: 14px;
  color: #000927;
  font-weight: 700;
  text-align: right;
}
#dialog .my_time {
  font-size: 11px;
  color: #9f9f9f;
}
.my_dialog {
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
}
.time {
  font-family: Noto Sans;
  font-size: 11px;
  color: #9f9f9f;
  margin: 4px 10px 4px 10px;
}
.my_dialog .content {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 12px 0 12px 12px;
  background: #00eec3;
  max-width: 600px;
  margin: 4px 10px 4px 10px;
  width: auto;
  float: left;
  max-width: 380px;
  word-break: break-all;
}
/* .my_dialog div {
  position: relative;
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 12px 0 12px 12px;
  background: #00eec3;
  max-width: 600px;
  margin: 4px 20px 4px auto;
  width: auto;
  float: right;
  max-width: 360px;
} */
.my_dialog div img {
  display: block;
  width: 100%;
}
.my_dialog .dow {
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 18px;
  bottom: 18px;
  cursor: pointer;
}
.Contacts_tit {
  background: #f1f3f5;
  line-height: 20px;
  padding: 10px 0 5px;
  font-size: 14px;
  color: #000;
  font-weight: 700;
  text-indent: 40px;
}
.Contacts_li {
  height: 24px;
  line-height: 24px;
  padding: 18px 0;
  border-bottom: 1px solid #e1e3e6;
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
.Contacts_li.mr {
  background: rgba(0, 238, 195, 0.1);
}
.Contacts_li div {
  width: 24px;
  height: 24px;
  float: left;
  margin: 0 15px 0 40px;
  border-radius: 12px;
  overflow: hidden;
}
.Contacts_li div img {
  width: 24px;
  height: 24px;
  float: left;
}
.dialog_img {
  width: 88px;
  border: 2px solid #f6f8fa;
  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  margin: 100px auto 0;
  overflow: hidden;
  height: 88px;
  border-radius: 50%;
}
.dialog_img img {
  width: 100%;
  height: 100%;
}
.dialog_name {
  margin: 0 auto;
  width: 400px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  color: #000927;
  text-align: center;
  font-weight: 700;
}
.dialog_num {
  margin: 20px auto 0;
  width: 400px;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  overflow: hidden;
  padding: 25px 0;
}
.dialog_num img {
  display: block;
  width: 40px;
  height: 40px;
  float: left;
  margin: 0 16px;
}
.dialog_num div {
  font-size: 13px;
  color: #9f9f9f;
  font-weight: 400;
  line-height: 20px;
}
.dialog_num div.dialog_num_t {
  font-size: 14px;
  color: #000927;
}
.dialog_num.msg3 div {
  text-indent: 24px;
}
.dialog_num.msg3 div.dialog_num_t {
  font-weight: 700;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/WahtsAppBusiness.vue